export default {
    escape_route: {
        name: "Escape Route",
        url: "nwcg_lines_safety/escape_route",
    },
}
